export default __webpack_public_path__ + "static/media/bg_banner_servicios.f1ec7ad4.png";